import { render, staticRenderFns } from "./customerAddress.vue?vue&type=template&id=1660353a&"
import script from "./customerAddress.vue?vue&type=script&lang=js&"
export * from "./customerAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports